import { Controller } from "@hotwired/stimulus"

// Persiste el tab activo de coaching en la URL (?tab_session=X).
// En connect(), si el URL pide un tab distinto al renderizado, hace click
// en el link correcto para que Turbo Frame cargue el contenido con sus ivars.
export default class extends Controller {
  static values = { currentTab: String }

  connect() {
    const desired = new URL(window.location.href).searchParams.get("tab_session")
    if (!desired || desired === this.currentTabValue) return

    const link = this.element.querySelector(`[href*="/${desired}"]`)
    link?.click()
  }

  navigate(event) {
    const url = new URL(window.location.href)
    url.searchParams.set("tab_session", this.tabFromHref(event.currentTarget.getAttribute("href") || ""))
    history.replaceState({}, "", url.toString())
  }

  tabFromHref(href) {
    if (href.includes("/calendar")) return "calendar"
    if (href.includes("/availability")) return "availability"
    return "scheduled"
  }
}
